/**
 * Constants for the "People You May Know" (Recommended Friends) surface.
 * testIDs and user-facing copy live here per project conventions.
 */

export const FRIENDS_SUGGESTIONS_TEST_IDS = {
  SECTION: 'people-you-may-know',
  EMPTY: 'people-you-may-know-empty',
  ERROR: 'people-you-may-know-error',
  ROW: 'suggestion-row',
  ADD_BUTTON: 'suggestion-add',
  DISMISS_BUTTON: 'suggestion-dismiss',
} as const

export const FRIENDS_SUGGESTIONS_COPY = {
  SECTION_LABEL: 'People you might know',
  EMPTY_TITLE: "You're all caught up",
  EMPTY_BODY: 'No new suggestions right now. Invite friends to grow your circle.',
  EMPTY_CTA: 'Invite friends',
  ERROR_TITLE: "Couldn't load suggestions",
  ERROR_CTA: 'Try again',
  ADD: 'Add',
  ADDED: 'Sent',
  ADD_SUCCESS: 'Friend request sent',
  ADD_FAILED: "Couldn't send request. Please try again.",
} as const
